import React from "react";
import { SkeletonCircle } from "@chakra-ui/react";
import { UserButtons } from "./UserButtons";
import { UserMenu } from "./UserMenu";
import { useUser } from "@utils";

export function UserStatus() {
  const { user, loading, error } = useUser();

  if (loading || error) {
    return <SkeletonCircle size="8" />;
  }

  if (!user) {
    return <UserButtons />;
  }

  return <UserMenu user={user} />;
}
